import script from "./ImageStylePanel.vue?vue&type=script&lang=ts&setup=true"
export * from "./ImageStylePanel.vue?vue&type=script&lang=ts&setup=true"

import "./ImageStylePanel.vue?vue&type=style&index=0&id=83015b08&lang=scss&scoped=true"

import exportComponent from "D:\\huishi-ppt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-83015b08"]])

export default __exports__